import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCBadger extends NPC {
    constructor() {
        super(definitions.NPC_ID.BADGER);

        this.collisionRadius = 15;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -32;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_badger_farmer_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.8, new PIXI.Point(1, -9));
        this.animateIdle(1);
    }

    onViewAdded() {
        super.onViewAdded();
    }
}